import { APP_INITIALIZER, enableProdMode, EnvironmentProviders, importProvidersFrom } from '@angular/core';


import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withHashLocation } from '@angular/router';
import { OrderByPipe, provideImpersonate } from '@sl/sl-angular-library';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { ImpersonateService } from './app/core/impersonate/services/impersonate.service';
import { LoadingInterceptor } from './app/core/services/interceptors/loading/loading-interceptor.service';
import { RoleService } from './app/core/services/role.service';
import { InjectorContainerModule } from './app/injector-container/injector-container.module';
import { TermPipe } from './app/shared/pipes/term.pipe';
import { ERole } from './app/shared/roles/models/role.enum';
import { environment } from './environments/environment';
import { authenticationInterceptor } from './app/interceptors/auth/auth.interceptor';

function initializeApp(roleService: RoleService) {
  return () => roleService.loadRoles();
}

if (environment.production) {
  enableProdMode();
}

const impersonateConfig =  {
  userService: ImpersonateService,
  historyKey: 'beaconImpersonateHistory',
  switchUserRole: ERole.SWITCH_USER as string
};

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(InjectorContainerModule, ReactiveFormsModule),
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [RoleService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    provideHttpClient(withInterceptors([authenticationInterceptor]), withInterceptorsFromDi(), withXsrfConfiguration({cookieName: 'CSRF-TOKEN', headerName: 'X-CSRF-TOKEN'})),
    provideAnimations(),
    provideRouter(routes, withHashLocation()),
    provideImpersonate(impersonateConfig),
    DatePipe,
    TermPipe,
    OrderByPipe
  ] as Array<EnvironmentProviders>
})
  .catch(err => console.error(err));
